import Vue from 'vue'
import Router from 'vue-router'

const agreement = r => require.ensure([], () => r(require('@/componentsforSimplearticle/agreement')), 'agreement')
const xieyi = r => require.ensure([], () => r(require('@/componentsforSimplearticle/xieyi')), 'xieyi')
const xieyi_sdk = r => require.ensure([], () => r(require('@/componentsforSimplearticle/xieyi-sdk')), 'xieyi-sdk')
const gxhyXieyi = r => require.ensure([], () => r(require('@/componentsforSimplearticle/gxhyXieyi')), 'gxhyXieyi')
const index = r => require.ensure([], () => r(require('@/components/index')), 'index')
const login = r => require.ensure([], () => r(require('@/components/login')), 'login')

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },{
      path: '/xieyi',
      name: 'xieyi',
      component: xieyi,
    },{
      path: '/xieyi-sdk',
      name: 'xieyi-sdk',
      component: xieyi_sdk,
    },{
      path: '/agreement',
      name: 'agreement',
      component: agreement,
    },{
      path: '/gxhyXieyi',
      name: 'gxhyXieyi',
      component: gxhyXieyi,
    },{
      path:'/index/shoplist',
      name:'isshoplist',
      component:r => require.ensure([], () => r(require('@/components/index_shoplist')), 'shoplist')
    },{
      path:'/index/pornshoplist',
      name:'ispornshoplist',
      component:r => require.ensure([], () => r(require('@/components/index_pornshoplist')), 'pornshoplist')
    },{
      path: '/index',
      name: 'index',
      component: index,
      children:[{
        path:'',
        name:'isindex',
        component:r => require.ensure([], () => r(require('@/components/index_index')), 'isindex')
      },
      {
        path:'/index/iscustomer',
        name:'iscustomer',
        component:r => require.ensure([], () => r(require('@/components/index_iscustomer')), 'iscustomer')
      },
    {path:'showcaseTwo',
	    name:'showcaseTwo',
	    component:r => require.ensure([], () => r(require('@/components/index_showcaseTwo')), 'showcaseTwo')
	  },
    {path:'istchgang',
	    name:'istchgang',
	    component:r => require.ensure([], () => r(require('@/components/index_istchgang')), 'istchgang')
	  },
    {
      path:'capitalOverview',
      name:'iscapitalOverview',
      component:r => require.ensure([], () => r(require('@/components/index_capitalOverview')), 'iscapitalOverview')
    },
    {
      path:'capitalInOutAccount',
      name:'iscapitalInOutAccount',
      component:r => require.ensure([], () => r(require('@/components/index_capitalInOutAccount')), 'iscapitalInOutAccount')
    },
    {
      path:'orderReview',
      name:'isorderReviewt',
      component:r => require.ensure([], () => r(require('@/components/index_orderReview')), 'orderReview')
    },
    {
      path:'orderTransactionDetail',
      name:'isorderTransactionDetail',
	  meta:{
		  keepAlive:true
	  },
      component:r => require.ensure([], () => r(require('@/components/index_orderTransactionDetail')), 'orderTransactionDetail'),
    },
    {
      path:'refundOrderDetail',
      name:'isrefundOrderDetail',
      component:r => require.ensure([], () => r(require('@/components/index_refundOrderDetail')), 'refundOrderDetail')
    },
    {
      path:'customerServiceOrder',
      name:'iscustomerServiceOrder',
      meta:{
        keepAlive:true
      },
      component:r => require.ensure([], () => r(require('@/components/index_customerServiceOrder')), 'customerServiceOrder')
    },
    {
      path:'orderSend',
      name:'orderSend',
      component:r => require.ensure([], () => r(require('@/components/index_orderSend')), 'orderSend')
    },
    {
      path:'bondAdmin',
      name:'isbondAdmin',
      component:r => require.ensure([], () => r(require('@/components/index_bondAdmin')), 'bondAdmin')
    },
    {
      path:'surrenderManagement',
      name:'issurrenderManagement',
      component:r => require.ensure([], () => r(require('@/components/index_surrenderManagement')), 'surrenderManagement')
    },
    {
      path:'inOutQuery',
      name:'isinOutQuery',
      component:r => require.ensure([], () => r(require('@/components/index_inOutQuery')), 'inOutQuery')
    },
    {
      path:'examineInOut',
      name:'isexamineInOut',
      component:r => require.ensure([], () => r(require('@/components/index_examineInOut')), 'examineInOut')
    },
    {
      path:'OneDayCapitalOverview',
      name:'isOneDayCapitalOverview',
      component:r => require.ensure([], () => r(require('@/components/index_OneDayCapitalOverview')), 'OneDayCapitalOverview')
    },
    {
      path:'withdrawalAppAdmin',
      name:'iswithdrawalAppAdmin',
      component:r => require.ensure([], () => r(require('@/components/index_withdrawalAppAdmin')), 'withdrawalAppAdmin')
    },
    {
      path:'sameDayOrder',
      name:'issameDayOrder',
      component:r => require.ensure([], () => r(require('@/components/index_sameDayOrder')), 'sameDayOrder')
    },
    {
      path:'orderDetail',
      name:'isorderDetail',

      component:r => require.ensure([], () => r(require('@/components/index_orderDetail')), 'orderDetail')

    },
	  {
        path:'user',
        name:'isuser',
        component:r => require.ensure([], () => r(require('@/components/index_user')), 'isuser')
      },{
        path:'datalook',
        name:'isdatalook',
        component:r => require.ensure([], () => r(require('@/components/index_datalook')), 'isdatalook')
      },{
        path:'tousu',
        name:'istousu',
        component:r => require.ensure([], () => r(require('@/components/index_tousu')), 'istousu')
      },{
        path:'tuisong',
        name:'istuisong',
        component:r => require.ensure([], () => r(require('@/components/index_tuisong')), 'tuisong')
      },{
        path:'yellow',
        name:'isyellow',
        component:r => require.ensure([], () => r(require('@/components/index_yellow')), 'yellow')
      },{
        path:'allcount',
        name:'isallcount',
        component:r => require.ensure([], () => r(require('@/components/index_allcount')), 'allcount')
      },{
        path:'adsSlide',
        name:'isadsSlide',
        component:r => require.ensure([], () => r(require('@/components/index_adsSlide')), 'adsSlide')
      },{
        path:'debug',
        name:'isdebug',
        component:r => require.ensure([], () => r(require('@/components/index_debugpage')), 'debug')
      },
      //
      {
        path:'emptypage',
        name:'isemptypage',
        component:r => require.ensure([], () => r(require('@/components/index_EMPTYPAGE')), 'emptypage')
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js